import React from 'react';
import type { ReactChildrenProp } from '../../lib';

type rightConProps = {
  children?: ReactChildrenProp;
};

export const RightContainer = ({ children }: rightConProps) => <div className="auth-inside-right-con">{children}</div>;
